import { createGetEnv } from '@bank/utils/createGetEnv';

export const isDevEnv = window.env.ENVIRONMENT === 'development';
export const isTestEnv = window.env.ENVIRONMENT === 'client-t';
export const isProdEnv = window.env.ENVIRONMENT === 'production';
/** Local E2E build: no backend, no Keycloak. See the `offline` env in `.iwarc.json`. */
export const isOfflineEnv = window.env.ENVIRONMENT === 'offline';

export const getEnv = createGetEnv({ isDevEnv, isProdEnv, isOfflineEnv });
